import { Heart } from "lucide-react";
import { useSavedLooks } from "../contexts/SavedLooksContext";
import { toast } from "sonner";

export default function SaveHeart({ outfitId, className = "", size = 18, dark = false }) {
  const { isSaved, toggleSave } = useSavedLooks();
  const saved = isSaved(outfitId);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const result = await toggleSave(outfitId);
    if (result?.needsLogin) return; // Login prompt will show via context
    if (result?.saved) toast.success("Saved to your looks");
    else if (result?.saved === false) toast.success("Removed from saved looks");
  };

  const fillClass = saved
    ? 'fill-red-500 text-red-500'
    : dark
      ? 'fill-transparent text-[#282828]/60 hover:text-[#9A7B4F]'
      : 'fill-transparent text-white/70 hover:text-white';

  return (
    <button
      onClick={handleClick}
      className={`flex items-center justify-center transition-all hover:scale-110 ${className}`}
      data-testid={`save-heart-${outfitId}`}
      aria-label={saved ? "Remove from saved" : "Save look"}
    >
      <Heart className={`transition-colors ${fillClass}`} style={{ width: size, height: size }} strokeWidth={dark ? 2 : 1.5} />
    </button>
  );
}
